import{React} from "react"
import Navbar from "./Navbar";
import Artists from "./Artists";



const ArtistsPage = () => {
  return (
    <div>
        <Navbar/>
        <Artists/>
    </div>
  );
};
export default ArtistsPage;